import React, { useState } from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLThemePicker } from '../../smartLinkDetailsView/rail/SMLThemePicker';
import { useEditorContext } from '../SMLEditorContext';

/**
 * The Look tab (design a5): the theme picker, moved here from the top of the old rail. The 8 themes
 * the account uses most, then "All 14 themes". A click saves the theme at once. The "Use the song
 * cover" and "Page header" toggles of the design are not approved (owner, 2026-10-20).
 */
const SMLLookTabComponent: React.FC = () => {
  const { smartLink } = useEditorContext();
  const [isExpanded, setExpanded] = useState(false);
  return <SMLThemePicker smartLink={smartLink} isExpanded={isExpanded} onExpandedChange={setExpanded} />;
};

export const SMLLookTab = TypedMemo(SMLLookTabComponent);
